"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RouteReporterAPI = function () {
  function RouteReporterAPI($http, $window, config) {
    (0, _classCallCheck3.default)(this, RouteReporterAPI);

    this.$http = $http;
    this.$window = $window;
    this.config = config;
  }

  (0, _createClass3.default)(RouteReporterAPI, [{
    key: "post",
    value: function post(url, data, options) {
      if (!this.config.apiUrl) throw Error("API URL Must be set during application startup");

      options = angular.extend({}, options, this.getOptions());

      return this.$http.post("" + this.config.apiUrl + url, data, options);
    }
  }, {
    key: "get",
    value: function get(url, options) {
      if (!this.config.apiUrl) throw Error("API URL Must be set during application startup");

      options = angular.extend({}, options, this.getOptions());

      return this.$http.get("" + this.config.apiUrl + url, options);
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      var userString = this.$window.sessionStorage["userAuthInfo"];
      var user = JSON.parse(userString);

      var options = {
        headers: {
          "ALK-Language": undefined,
          "Authorization": "Bearer " + user.authToken
        }
      };

      return options;
    }
  }, {
    key: "isArray",
    value: function isArray(arg) {
      return Object.prototype.toString.call(arg) === "[object Array]";
    }
  }]);
  return RouteReporterAPI;
}();

exports.default = RouteReporterAPI;


RouteReporterAPI.$inject = ["$http", "$window", "alk.routereporter.config"];


// WEBPACK FOOTER //
// ./app/alk-fleetview/routereporter.api.js